import { createAction, createReducer } from '@reduxjs/toolkit';
import { get } from 'lodash-es';

const MODULE_PREFIX = ` [ FUNDS WITHDRAW SCREEN ] `;
const Actions = {
	fetchWithdrawFundsSummery: `${MODULE_PREFIX} fetchWithdrawFundsSummery`,
	setWithdrawFundsSummery: `${MODULE_PREFIX} setWithdrawFundsSummery`,
	createWithdrawFundsRequest: `${MODULE_PREFIX} createWithdrawFundsRequest`,
	cancelWithdrawRequest: `${MODULE_PREFIX} cancelWithdrawRequest`,
	modifyWithdrawRequest: `${MODULE_PREFIX} modifyWithdrawRequest`,
};
//======= Actions

export const fetchWithdrawFundsSummery = createAction(
	Actions.fetchWithdrawFundsSummery,
);
export const createWithdrawFundsRequest = createAction(
	Actions.createWithdrawFundsRequest,
);
export const cancelWithdrawRequest = createAction(
	Actions.cancelWithdrawRequest,
);

export const modifyWithdrawRequest = createAction(
	Actions.modifyWithdrawRequest,
);
export const setWithdrawFundsSummery = createAction(
	Actions.setWithdrawFundsSummery,
);

//==== END ACTIONS
// ============= Selector

export const getWithdrawFundsSummery = (state) => {
	const withdrawFundsData = get(state, 'withdrawFunds.withdrawFundsData', {});
	return withdrawFundsData;
};

export const getWithdrawPendingData = (state) => {
	return get(state, 'withdrawFunds.withdrawFundsData.payout_request', {});
};
/// ============= END SELECTOR

const initialState = {
	withdrawFundsData: {},
};

export default createReducer(initialState, (builder) => {
	builder.addCase(setWithdrawFundsSummery, (state, action) => {
		state.withdrawFundsData = action.payload;
	});
});
